import { render, staticRenderFns } from "./TroubleshootingSection.vue?vue&type=template&id=0219f85e&scoped=true&"
import script from "./TroubleshootingSection.vue?vue&type=script&lang=ts&"
export * from "./TroubleshootingSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219f85e",
  null
  
)

export default component.exports